<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12" sm="12" offset-sm="0">
        <v-card id="mealListcard">
          <h2 v-if="!!!items">Keine Gerichte gefunden</h2>
          <v-container>
            <v-row>
              <v-col>
                <v-btn
                  @click="confirmDeleteSelected"
                  dark
                  color="red"
                  :disabled="selected.length == 0"
                >
                  <v-icon>mdi-delete</v-icon> Auswahl löschen</v-btn
                >
              </v-col>
            </v-row>
          </v-container>
          <v-data-table
            :headers="headers"
            :items="items"
            item-key="gerichtnr"
            :search="mealSearch"
            :itemsPerPage="-1"
            class="dataRow"
            multi-sort
            show-select
            v-model="selected"
          >
            <template slot="item.preis" slot-scope="{ item }">
              {{ currencyFormat(item.preis) }}
            </template>

            <template slot="item.kategorie" slot-scope="{ item }">
              {{ item.kategorie
              }}<span v-if="item.subkategorie">, {{ item.subkategorie }}</span>
            </template>

            <template slot="item.vegetarisch" slot-scope="{ item }">
              <v-icon v-if="item.vegetarisch" color="success"
                >mdi-check-circle-outline</v-icon
              >
              <v-icon v-else color="error">mdi-cancel</v-icon>
            </template>

            <template slot="item.glutenfrei" slot-scope="{ item }">
              <v-icon v-if="item.glutenfrei" color="success"
                >mdi-check-circle-outline</v-icon
              >
              <v-icon v-else color="error">mdi-cancel</v-icon>
            </template>

            <template slot="item.grossgebinde" slot-scope="{ item }">
              <v-icon v-if="item.grossgebinde" color="success"
                >mdi-check-circle-outline</v-icon
              >
            </template>

            <template slot="item.laktosefrei" slot-scope="{ item }">
              <v-icon v-if="item.laktosefrei" color="success"
                >mdi-check-circle-outline</v-icon
              >
              <v-icon v-else color="error">mdi-cancel</v-icon>
            </template>

            <template slot="item.schweinefleischfrei" slot-scope="{ item }">
              <v-icon v-if="item.schweinefleischfrei" color="success"
                >mdi-check-circle-outline</v-icon
              >
              <v-icon v-else color="error">mdi-cancel</v-icon>
            </template>

            <template slot="item.von" slot-scope="{ item }">
              {{ formatDate(item.von) }}
            </template>

            <template slot="item.bis" slot-scope="{ item }">
              {{ formatDate(item.bis) }}
            </template>

            <template slot="item.actions" slot-scope="{ item }">
              <v-icon small class="mr-2" @click="editItem(item)"
                >mdi-pencil</v-icon
              >
              <v-icon small class="mr-2" @click="askDeleteGericht(item)"
                >mdi-delete</v-icon
              >
            </template>
          </v-data-table>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import moment from "moment";

export default {
  name: "MealList",
  props: {
    items: {
      type: Array,
      required: true
    }
  },
  data: () => ({
    selected: [],
    headers: [
      { text: "Gerichtnr", value: "gerichtnr", width: "120px" },
      { text: "Kategorie", value: "kategorie", width: "150px" },
      { text: "Name", value: "name" },
      { text: "Schweinefrei", value: "schweinefleischfrei", width: "80px" },
      { text: "Laktosefrei", value: "laktosefrei", width: "80px" },
      { text: "Glutenfrei", value: "glutenfrei", width: "80px" },
      { text: "Vegetarisch", value: "vegetarisch", width: "80px" },
      { text: "Großgebinde", value: "grossgebinde", width: "80px" },
      { text: "Preis", value: "preis", width: "100px", align: "right" },
      { text: "Von", value: "von", width: "100px", align: "right" },
      { text: "Bis", value: "bis", width: "100px", align: "right" },

      {
        text: "Actions",
        value: "actions",
        sortable: false,
        width: "110px",
        align: "right"
      }
    ]
  }),
  components: {},
  methods: {
    confirmDeleteSelected() {
      this.$emit("deleteSelectedItems", this.selected);
    },
    formatDate(date) {
      return moment(date).format("DD.MM.YYYY");
    },
    askDeleteGericht(item) {
      this.$emit("deleteItem", item);
    },
    editItem(item) {
      this.$emit("editItem", item);
    },

    currencyFormat(value = 0) {
      return new Intl.NumberFormat("de-DE", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      }).format(value);
    }
  },

  computed: {
    kategorien() {
      return this.$store.getters["meal/getKategorien"];
    },
    mealSearch() {
      return this.$store.getters["meal/getMealSearch"];
    }
  },

  created() {}
};
</script>

<style scoped>
#Gerichtlistcard {
  margin: 20px;
}

.v-data-table__selected {
  background: #e0f4cb !important;
}
</style>
